import { reducers } from 'redux/core'


const open = (name, data, options) => reducers.models.modals.open({ name, data, options })

const close = (name) => reducers.models.modals.close(name)

const update = (name, data) => reducers.models.modals.update({ name, data })

const closeAll = reducers.models.modals.closeAll


export default {
  open,
  close,
  update,
  closeAll,
}
